// extracted by mini-css-extract-plugin
export default {"wrapper":"p9-z"};